import React, { Component } from "react";
import { alert, t } from "../../../components/CustomComponent.js";
import { lineAddUrl } from "../../../components/people_option.js";
import { getCompany, loadCompany, subscribeCompany } from "../../../services/company.service.js";
import { contactChannels } from "../options.js";
import { CONTACT_ICONS } from "../api.js";
import ICON from "../icons.js";
import LINE_ICON from "../../../assets/images/icon-line.png";

/* ============================================================================
 * HomeCta — แถบชวนติดต่อสอบถาม ปิดท้ายก่อนฟุตเตอร์
 *
 * รวมทุกช่องทางติดต่อไว้บรรทัดเดียว (โทร / LINE / อีเมล) ผู้ใช้ที่ยังไม่พร้อม
 * ลงประกาศแต่มีคำถาม จะได้ไม่ต้องเลื่อนลงไปหาเบอร์ในฟุตเตอร์
 *
 * ข้อความหัวเรื่องแก้ได้จากหลังบ้าน (/ad/home/contact) ส่วนตัวช่องทางเองมาจาก
 * "ตั้งค่า › ข้อมูลบริษัท" ผ่าน company.service (ดู contactChannels ใน options.js)
 * จึงตรงกับเบอร์/อีเมลที่ใช้ในเอกสารและหน้าอื่นของระบบเสมอ
 *
 * ไม่มีปุ่ม "ติดต่อเรา" แยกอีกปุ่ม — ระบบยังไม่มีฟอร์มติดต่อ ปุ่มที่กดแล้วเด้ง
 * "กำลังพัฒนา" อยู่ติดกับช่องทางที่ใช้ได้จริงมีแต่ทำให้คนกดผิด
 *
 * โทรและ LINE ถามยืนยันก่อนเสมอ (แบบเดียวกับ HomeCardContact) — แถบนี้อยู่ท้ายหน้า
 * ที่คนเลื่อนผ่านด้วยนิ้ว กดพลาดแล้วโทรออกทันทีจะแก้ไม่ทัน และเครื่องที่โทรไม่ได้
 * จะได้เห็นเบอร์ไว้กดจากอีกเครื่อง
 * ========================================================================== */
export default class HomeCta extends Component {
  state = { company: getCompany() };

  componentDidMount() {
    this.unsubscribeCompany = subscribeCompany((company) => this.setState({ company }));
    loadCompany(); // ยิงครั้งเดียวต่อการเปิดเว็บ — เรียกซ้ำได้ ตัว service กันไว้ให้แล้ว
  }

  componentWillUnmount() {
    if (this.unsubscribeCompany) this.unsubscribeCompany();
  }

  /* tel: รับได้เฉพาะตัวเลขกับ + — เบอร์ที่พิมพ์มาเป็น 02-123-4567 ต้องล้างขีดออกก่อน */
  call = async (value) => {
    const dial = String(value).replace(/[^\d+]/g, "");
    if (!(await alert("", "info", t("home_cta_call_confirm"), value, t("home_contact_call"), t("cancel")))) return;
    window.location.href = `tel:${dial}`;
  };

  line = async (event, url, value) => {
    event.preventDefault();
    if (!(await alert("", "info", t("home_cta_line_confirm"), value, t("home_contact_line_add"), t("cancel")))) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  /** ไอคอนของช่องทาง — LINE ใช้โลโก้จริง ที่เหลือใช้ไอคอนตัวอักษรชุดเดียวกับทั้งหน้า */
  icon = (kind) =>
    kind === "line" ? (
      <span className="hm-channel__icon hm-channel__icon--line">
        <img src={LINE_ICON} alt="" />
      </span>
    ) : (
      <span className="hm-channel__icon hm-ico">{CONTACT_ICONS[kind] || ICON.info}</span>
    );

  renderChannel = (item) => {
    const label = this.icon(item.kind);

    if (item.kind === "phone") {
      return (
        <button
          key={item.key}
          type="button"
          className="hm-channel"
          title={`${t("home_contact_call")} ${item.value}`}
          onClick={() => this.call(item.value)}
        >
          {label}
          <span>{item.value}</span>
        </button>
      );
    }

    if (item.kind === "line") {
      const url = lineAddUrl(item.value);
      if (!url) return null;
      /* เป็น <a> จริงเพื่อให้กดค้างคัดลอก/แชร์ลิงก์ได้ ส่วนการกดปกติดักไว้ถามก่อน */
      return (
        <a
          key={item.key}
          className="hm-channel"
          href={url}
          target="_blank"
          rel="noreferrer"
          title={t("home_contact_line_add")}
          onClick={(e) => this.line(e, url, item.value)}
        >
          {label}
          <span>{item.value}</span>
        </a>
      );
    }

    if (item.kind === "mail") {
      return (
        <a key={item.key} className="hm-channel" href={`mailto:${item.value}`} title={t("email")}>
          {label}
          <span>{item.value}</span>
        </a>
      );
    }

    /* ที่อยู่ / เวลาทำการ — เป็นข้อมูลบอกเล่า ไม่ใช่ปุ่ม จึงไม่ให้กด */
    return (
      <span key={item.key} className="hm-channel is-static">
        {label}
        <span>{item.value}</span>
      </span>
    );
  };

  render() {
    const { data } = this.props;
    const channels = contactChannels(this.state.company, data?.items);

    return (
      <div className="hm-container" id="hm-contact">
        <section className="hm-cta">
          <div className="hm-cta__text">
            <h2 className="hm-cta__title">{data?.title || ""}</h2>
            <p className="hm-cta__desc">{data?.desc || ""}</p>
          </div>

          <div className="hm-cta__channels">{channels.map(this.renderChannel)}</div>
        </section>
      </div>
    );
  }
}
